import { h } from "preact"
import { useVersion } from "./VersionProvider"

export default function Footer() {
    const version = useVersion()

    return (
        <footer className="layout container-fluid my-2 small text-muted">
            ISBJ Portal-Anmeldung
            {!version.loading && (
                <>
                    {" "}
                    {version.version} – {version.buildtimestamp} – {version.revision}
                </>
            )}
        </footer>
    )
}
